import { post, fetch, Del, put } from "@/ask/axios";
import { Generalcargo } from "@/ask/util";
import { getCookie } from "@/ask/cookiejs";
import bus from "@/ask/eventBus";
import { getCustomer } from "@/utils/getCustomer";
import AirDest from "@/components/Reception/public/airDest.vue";
import DestOption from "@/components/Reception/public/destOption.vue";
import startCityeara from "@/components/userCenter/air/component/startCity.vue";
import contraband from "@/components/userCenter/public/contraband.vue";
import CopyPriceDialog from "@/components/userCenter/air/copyPriceDialog.vue";
import reuqestPriceUpdate from "@/components/userCenter/air/reuqestPriceUpdate.vue";
import { elAlert } from "@/utils/bulletBox";
import progressLoading from "@/components/Reception/public/progressLoading.vue";
export default {
  components: {
    AirDest,
    DestOption,
    startCityeara,
    contraband,
    CopyPriceDialog,
    reuqestPriceUpdate,
    progressLoading
  },
  data() {
    return {
      valueObj: {},
      isFirst500Dialog: true,
      anyTimeNotContain: false,
      KgShowline: "",
      AirlineBox: [],
      airlinelist: [],
      airlineOrigin: [],
      cargoShow: false,

      startCityInfo: {},
      Emailenter: false, //邮箱弹框验证
      Email: "",
      curChannelList: null, //当前的渠道列表信息
      channelList: [],
      isLoading: false, //加载中...
      unitValue: "CTNS",
      //总量信息计算
      unitOptions: [
        { value: "CTNS", label: "Carton" },
        { value: "PLTS", label: "Pallet" },
        { value: "WOODEN CASE", label: "Wooden Case" },
        { value: "OTHER", label: "Other" }
      ],
      weightValue: "KG",
      weightOptions: [
        { id: 1, value: "KG", label: "KG" },
        { id: 2, value: "LB", label: "LB" }
      ],
      volumeValue: "CM",
      volumeOptions: [
        { id: 1, value: "CM", label: "CM" },
        { id: 2, value: "IN", label: "IN" }
      ],
      volumeValue1: "CBM",
      volumeOptions1: [
        { id: 1, value: "CBM", label: "CBM" },
        { id: 2, value: "CFT", label: "CFT" }
      ],
      incotermsValue: "5",
      chkInputOptions: [
        { value: "5", label: "FOB" },
        { value: "6", label: "EXW" },
        { value: "7", label: "FCA" }
      ],
      ShippmentOptions: [
        { value: 1, label: "Calculate by boxes/pallets" },
        { value: 2, label: "Calculate by total shipment" },
      ],
      Airline: [],
      destList: [],
      DestCountry: [], //目的国家存放
      bfDestAirPort: [],
      toleNum: 5,
      showMore: true,
      showOrigin: true,
      originNum: 5,
      basicInfo: [], //查价列表
      VolumeUnit: 1,
      destAirportList: [],
      // //验证提示
      checkTip: {
        destTips: "Destination Airport",
        startCity: "",
        inputUnitsTip: "",
        inputWeightTip: "",
        inputCBMTip: "",
        inputCFBTip: "",
        inputLBTip: ""
      },
      destShow: false,
      destAirPort: {},
      QueryType: 2,
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },
      WCAQueryCountryKey: "", //wca成员显示的目的机场
      feeList: [], //报价详情展开[]代表没有展开
      orderSort: "comprehensive",
      // 设置地址
      setData: {
        City: {}
      },
      Recent: {
        StartCity: []
      },
      //货物种类弹框
      cargoBox: false,
      cargoVal: [],
      cargoInfo: [],
      GenCargoVal: false, //选择普货
      readInfo: false, //是否阅读违禁物品

      showSHReport: false, //是否显示上海化工报告
      IsSHReport: null, //选择上海化工报告

      geCargoID: sysCfg.air.Cargo.generalCargoID, //普货ID
      porCargoID: null, //移动电源ID
      batteryCargoID: null, //纯电池ID
      // 货物信息
      radCargo: [
        {
          Quanlity: "",
          Long: "",
          Wide: "",
          Height: "",
          High: "",
          Volume: "",
          Weight: "",
          LongIN: "",
          WideIN: "",
          HighIN: "",
          VolumeCFT: "",
          WeightLB: "",
          isCol1: false,
          isCol2: false,
          isCol3: false,
          unitOptions: [
            { value: 1, label: "Carton" },
            { value: 2, label: "Pallet" },
            { value: 3, label: "Wooden Case" },
            { value: 4, label: "Other" }
          ],
          Unit: 1
        }
      ],
      Sum: {
        sumUnits: 0,
        sumKG: 0,
        sumLB: 0,
        sumCBM: 0,
        sumCFT: 0
      },
      inputUnits: null, //输入件数
      inputWeight: null, //输入重量
      inputCBM: null, //输入总体积
      startCityInfo: {},
      isSum: false, //是否可以点击查价按钮
      cargoTypeIDList: [Number(this.geCargoID)],
      isOthers: false,
      sortList: [
        {
          title: "Comprehensive",
          val: "comprehensive"
        },
        {
          title: "Cheapest",
          val: "price"
        },
        {
          title: "Top-selling",
          val: "expsale"
        },
        {
          title: "Quickest",
          val: "workday"
        }
      ],
      Density: [
        {
          title: "General",
          val: "General"
        },
        {
          title: "1:300",
          val: "1:300"
        },
        {
          title: "1:500",
          val: "1:500"
        },
        {
          title: "1:1000",
          val: "1:1000"
        }
      ],
      curDensity: "1:300",
      ipObj: "",
      chooseArray: [], // 复制报价
      copyDialog: false, // 更新报价弹框
      requestDialog: false,
      copyPriceData: [],
      AirPriceStoreListStatus: [],
      infoActive: -1,
      itemInfo: [],
      startAirList: [],
      startCityenter: false,
      destAirList: [],
      airFeeList: [], //存储费用集合
      customerOwnerType: null, //同行直客
      CustomerID: 0,
      arrivalType: false,
      destListBox: [],
      destListShow: true,
      OriginListshow: true,
      indexed: 0,
      isShowMore: false,
      topQuery: true,
      leftQuery: true,
      tiaoshu: 10,
      curAddress: "", //保存当前的地址库信息
      showMoreList: true,
      showStow: true,
      showSvg: false,
      derNumber: false,
      isCheckSortBy: false,
      startAirportCodeList: null,
      airCompanyKeyList: null,
      checkAirCount: 0,//记录左侧航司选中次数
      checkOreCount: 0,//记录左侧起始地选中次数
      newList: [],//新存放的list集合
      inquiryShow: false,//是否显示大货询盘按钮
    };
  },
  created() {
    this.getRecent();
    //获取用户信息
    let U_info = JSON.parse(sessionStorage.getItem("customerInfos"));
    if (U_info) {
      this.customerOwnerType = U_info.CustomerOwnerType;
      this.CustomerID = U_info.CustomerID;
    }

    this.channelList.forEach(item => {
      item.showFee = false;
      item.showleft = true;
    });
    //判断是登录过来的  还是首页过来的
    var query = window.location.search;

    if (query) {
      //首页过来的
      // console.log("======首页过来的")
      if (this.$route.query.code1.split(",").length > 1) {
        this.startAirList = null;
      } else {
        this.startAirList = this.$route.query.code1.split(","); //起始地
      }

      this.destList = this.$route.query.code2.split(","); //目的地
      this.inputUnits = this.$route.query.unitQty;
      this.inputWeight = this.$route.query.weight;
      this.inputCBM = this.$route.query.cbm;
      this.cargoVal = this.$route.query.cargoId
        .split(",")
        .map(item => item - 0);
      this.cargoVal.length === 0 &&
        (this.cargoVal = this.cargoVal[sysCfg.air.Cargo.generalCargoID]);
      // debugger
      this.cargoVal[0] !== sysCfg.air.Cargo.generalCargoID
        ? (this.cargoShow = true)
        : "";
    } else {
      //登录   起始地为默认的五大机场 目的地为ip获取
      this.startAirList = [
        "SZX",
        "HKG",
        "CAN",
        "PVG",
        "PEK",
        "CGO",
        "CSX",
        "TSN",
        "XMN",
        "WUH",
        "KMG",
        "NNG",
        "KHN",
        "TAO",
        "SHA",
        "CTU",
        "XIY",
        "HGH",
        "YNZ",
        "TNA",
        "CKG",
        "URC",
        "NTG",
        "MFM",
        "SJW",
        "NKG",
        "NGB"
      ]; //默认的五大机场

      this.$store.dispatch("user/getIP").then(res => {
        this.destAirList = res.DestinationData;
        // this.DestCountry = res.SysAirPortRet;
        if (res.SysAirPortRet) {
          this.destList.push(res.SysAirPortRet.AirportCode3); //目的机场ip获取
        }
      });
    }
    let weight = this.inputWeight ? this.inputWeight : 500;
    let CBM = this.inputCBM ? this.inputCBM : 1.5;
    this.showDensity(weight / CBM);
    this.showKg(this.inputWeight);
    this.getCargoApi(); //货物种类接口
  },

  mounted() {
    //普货id
    this.geCargoID = sysCfg.air.Cargo.generalCargoID; //普货 ID
    this.porCargoID = sysCfg.air.Cargo.porCargoID; //移动电源ID
    this.batteryCargoID = sysCfg.air.Cargo.batteryCargoID; //纯电池ID

    //console.log("获取存储的值",localStorage.getItem('historyItems'));
    this.getDestAirApi(); //起运机场接口
    this.anyTimeNotContain = localStorage.getItem("anyTimeNotContain") == "true"; //任何时间都没违规
    this.$store.dispatch("user/getIP").then(res => {
      //上一次查价目的机场记录
      let obj = JSON.parse(localStorage.getItem('historyItems'));
      if (obj) {
        if (obj.CustomerID == this.CustomerID) {//同一个用户
          if (obj.destList.length > 0) {
            this.destListBox = obj.destListBox
            this.destList = obj.destList
            this.DestCountry = obj.DestCountry
          }
        }
      } else {
        this.destAirList = res.DestinationData;
        //this.DestCountry = res.SysAirPortRet;
        if (res.SysAirPortRet) {
          this.destList.push(res.SysAirPortRet.AirportCode3); //目的机场ip获取
          this.DestCountry = res.DestinationData.DestCountryNameCn.split(",");
        }
        //console.log("mudijichang====",this.destList,this.destListBox);
        if (this.destList.length == 0) {

          let aa = JSON.parse(getCookie("saveCustomerOwnerType"));
          let registerCountry = aa.registerCountry;
          let queryParma = {};
          let U_info = JSON.parse(sessionStorage.getItem("customerInfos"));
          //目的国家
          if (U_info) {
            queryParma = {
              Country: U_info.RegisterCountry
            };
          } else {
            queryParma = {
              Country: registerCountry
            };
          }
          let url = this.$api04 + "/Air/api/GetCountry/GetCityCode3";
          fetch(url, queryParma).then(res => {
            if (res.IsOK == true) {
              this.destList.push(res.Results);
            }
          });
        }
      }
      if (this.$route.query.code2) {
        this.destList = this.$route.query.code2.split(","); //目的地
        this.destListBox = this.destList
        if (this.$route.query.CountryNameCh) {
          this.DestCountry = this.$route.query.CountryNameCh.split(",");//目的国家
        }

      }


      let cargoStrID = "";
      let cargoStrList = []
      if (this.$route.query.cargoId) {
        cargoStrID = this.$route.query.cargoId.split(",");
        this.cargoInfo.filter(item => {
          if (this.$route.query.cargoId.includes(item.Id)) {
            cargoStrList.push(item.AttrVal_Content);
          }
          return cargoStrList;
        });
        cargoStrList = cargoStrList;
      }
      //埋点
      let isGoods = true
      if (cargoStrID == "") {
        isGoods = false
      }
      if (cargoStrID == sysCfg.air.Cargo.generalCargoID) {
        isGoods = false
      }
      let destValue = ''  //= this.DestCountry
      if (typeof this.DestCountry == Object) {
        destValue = this.DestCountry.join()
      }
      if (typeof this.DestCountry == String) {
        destValue = this.DestCountry
      }

      let inputWeight = this.$route.query.weight ? this.$route.query.weight : Number(this.inputWeight) ? Number(this.inputWeight) : 500;
      let inputCBM = this.$route.query.cbm ? this.$route.query.cbm : Number(this.inputCBM) ? Number(this.inputCBM) : 1.5;
      let inputUnits = this.$route.query.unitQty ? this.$route.query.unitQty : Number(this.inputUnits) ? Number(this.inputUnits) : 1

      //当选择货物信息时，只要包含了托盘，木箱和其他，就只显示托盘的价格
      //包材类型PackagingType 1：纸箱，2：托盘
      let PackagingType = 1;
      if (this.$route.query.unitLabel != "CTNS") {//总的
        PackagingType = 2;
      }
      this.unitValue = this.$route.query.unitLabel || 'CTNS';

      console.log('');

      let queryParma = {
        skip: 0,
        take: 9999,
        orderBy: this.orderSort ? this.orderSort : "comprehensive",
        orderByDesc: "aa",
        customerID: this.CustomerID,
        customerOwnerType: this.customerOwnerType ? this.customerOwnerType : 2,
        // orderServiceType: 5, //机场到机场 默认是3
        goodsReadyTime: new Date().Format("yyyy-MM-dd"), //"2021-06-24T06:25:09.016Z",//
        //channelKey: '',//渠道Key
        //channelOwnerType: 0,
        //startCityKey: this.$route.query.startCityKey,//起运城市Key
        startAirportCodeList: this.startAirList
          ? this.startAirList.length > 1
            ? null
            : this.startAirList
          : null,
        destAirportCodeList: this.destListBox.length > 0 ? this.destListBox : this.destList, //(this.destList.join()=='SZX' || this.destList)?['LAX']:this.destList,
        //arrivalType: 0,
        //airCompanyKeyList: this.airlinelist!=0?this.airlinelist:null,//航空公司Key
        weight:
          this.Sum.sumKG == 0
            ? Number(this.inputWeight) == 0
              ? 500
              : Number(this.inputWeight)
            : this.Sum.sumKG,
        volume:
          this.Sum.sumCBM == 0
            ? Number(this.inputCBM) == 0
              ? 1.5
              : Number(this.inputCBM)
            : this.Sum.sumCBM,
        quantity: this.inputUnits ? Number(this.inputUnits) : 1,
        cargoTypeIDList: cargoStrID ? cargoStrID : [this.geCargoID],
        PackagingType: PackagingType,
        "platformType": "web",
        "isLogin": true,
        "entrance": "Air Freight"
      };
      //邮件推广点击过来。渠道传的是集合。默认五条数据
      let channelKeys = this.$route.query.channelKeys;
      if (channelKeys) {
        queryParma['channelKeys'] = channelKeys.split(",");
        queryParma['orderBy'] = "price";
      }
      //console.log("=======>>>>",JSON.stringify(queryParma));
      let url = this.$api04 + "/Air/api/AirCalculation/QueryPriceEn";
      post(url, queryParma).then(res => {
        if (res.IsOK == true) {
          this.searchResult(res.Results.Total, '国际空运', res.Results.Origin.join(), '', res.Results.Dest.join(), '', false)
          this.isLoading = false;
          this.channelList = res.Results.List;
          this.newList = this.channelList;
          this.channelList.forEach(item => {
            item.showFee = false;
            item.showleft = true;
            this.showKg(item.AirChargeWeight);
            let sumAll = 0;
            let sumSubtotal = 0;
            sumAll = item.AirTracficFee + item.THAmount;
            sumSubtotal = item.THAmount;
            if (item.LstAirFee) {
              item.LstAirFee.forEach(val => {
                sumAll += val.Amount;
                sumSubtotal += val.Amount;
              });
            }
            item.AllsumSubtotal = sumSubtotal;
            item.AllFee = sumAll;
          });

          this.Airline = res.Results.Airline;
          this.startAirList = res.Results.Origin;

          //this.destList = res.Results.Dest;
          this.destList = this.queryfirstValue(this.destList);
          //this.destListBox = res.Results.Dest;
          let codeList = [];
          this.Airline.filter(function (elem) {
            codeList.push(elem.Code);
            return codeList;
          });
          this.airlinelist = codeList;
          this.airlineOrigin = this.startAirList;
          this.cargoBox = false;
          this.anyTimeNotContainAnd500Dialog();
        } else {
          // elAlert(this, "error");
        }
      });
    });
  },
  computed: {
    //计算属性周期函数

    sumUnit() {
      //件数总计
      let num = 0;
      if (this.radCargo) {
        this.radCargo.forEach(e => {
          num += Number(e.Quanlity);
        });
        if (isNaN(num)) {
          return 0;
        }
      }
      this.Sum.sumUnits = num;
      return num;
    },
    //KG单位换算
    sumKG() {
      let num = 0;
      this.radCargo.forEach(e => {
        if (this.weightValue == "KG") {
          num += Number(e.Quanlity) * Number(e.Weight);
        } else {
          num += Number(e.Quanlity) * (Number(e.Weight) * 0.4535924);
        }
      });

      if (isNaN(num)) {
        return 0;
      }
      this.Sum.sumKG = num;
      return num.toFixed(3);
    },
    //磅单位换算
    sumLB() {
      let num = 0;
      //VolumeUnit=0 KG；VolumeUnit=1 LB
      if (this.weightValue == "KG") {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += Number(e.Quanlity) * (Number(e.Weight) * 2.2046226);
          });
        }
      } else if (this.weightValue == "LB") {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += Number(e.Quanlity) * Number(e.Weight);
          });
        }
      }
      if (isNaN(num)) {
        return 0;
      }
      this.Sum.sumLB = num;
      return num.toFixed(3);
    },
    //CBM单位换算
    sumCBM() {
      // console.log("kankanaknak",this.radCargo);
      let num = 0;
      this.radCargo.forEach(e => {
        if (this.volumeValue == "CM") {
          num +=
            ((Number(e.Long) * Number(e.Wide) * Number(e.High)) / 1000000) *
            Number(e.Quanlity);
        } else {
          num +=
            Number(e.Long) *
            Number(e.Wide) *
            Number(e.High) *
            Number(e.Quanlity) *
            0.000016387064;
        }
      });
      // if (this.volumeValue=="CBM") {
      //   if (this.radCargo) {
      //     this.radCargo.forEach(e => {
      //       num += (Number(e.Long) * Number(e.Wide) * Number(e.Height) / 1000000) * Number(e.Quanlity)
      //     });
      //   }
      // } else if (this.volumeValue=="CFT") {
      //   if (this.radCargo) {
      //     this.radCargo.forEach(e => {
      //       num += (Number(e.LongIN)  * Number(e.WideIN) * Number(e.HighIN)  * Number(e.Quanlity) * 0.000016387064)
      //     });
      //   }
      // }
      if (isNaN(num)) {
        return 0;
      }
      this.Sum.sumCBM = num;
      // console.log("kankanaknak",num);
      return num.toFixed(4);
    },
    sumCFT() {
      let num = 0;
      this.radCargo.forEach(e => {
        if (this.volumeValue == "CM") {
          num +=
            ((Number(e.Long) * Number(e.Wide) * Number(e.High)) / 1000000) *
            Number(e.Quanlity) *
            35.3147248;
        } else {
          num +=
            Number(e.Long) *
            Number(e.Wide) *
            Number(e.High) *
            0.000016387064 *
            35.3147248 *
            e.Quanlity;
        }
      });
      // if (this.volumeValue=="CBM") {
      //   if (this.radCargo) {
      //     this.radCargo.forEach(e => {
      //       num += Number(e.Long)* Number(e.Wide)  * Number(e.Height) / 1000000 * Number(e.Quanlity) *35.3147248
      //     });
      //   }
      // } else if (this.volumeValue=="CFT") {
      //   if (this.radCargo) {
      //     this.radCargo.forEach(e => {
      //       num += (((Number(e.LongIN)* Number(e.WideIN) * Number(e.HighIN))*0.000016387064 *35.3147248) * e.Quanlity) ;
      //     });
      //   }
      // }
      if (isNaN(num)) {
        return 0;
      }
      this.Sum.sumCFT = num;
      return num.toFixed(4);
    }
  },
  methods: {
    Verification() {
      let Resolve = true
      if (this.QueryType == 2) {

        ['inputUnits', 'inputWeight', 'inputCBM'].forEach(ele => {
          if (!this[ele]) {
            var Tip = `${ele}Tip`
            this.checkTip[Tip] = 'Required'
            Resolve = false
          }
        });

      } else {
        this.radCargo.forEach(el => {
          if (!el.Quanlity) {
            el.isCol1 = true
            Resolve = false
          }
          if (!el.Long || !el.Wide || !el.Quanlity) {
            el.isCol2 = true
            Resolve = false
          }
          if (!el.Weight) {
            el.isCol3 = true
            Resolve = false
          }
        });

      }
      if (!Resolve) {
        return false
      } else {
        return true
      }
    },
    //localStorage.setItem('historyItems', JSON.stringify(this.destList))
    getNewList(item) {
      this.newList = item
      if (this.newList.length > 10) {
        this.showStow = true;
        this.showMoreList = true;
        this.tiaoshu = 10
      } else {
        this.showMoreList = false;
      }
    },
    // 保存历史记录
    clearHistoryItems() {
      // 清空历史记录
      localStorage.removeItem('historyItems')
      let obj = {
        destListBox: this.destListBox,//选中记录
        destList: this.destList,//查询记录
        CustomerID: this.CustomerID,//用户id
        DestCountry: this.DestCountry//目的国家
      }
      localStorage.setItem('historyItems', JSON.stringify(obj))
    },

    // dest隐藏
    blurHide() {
      this.destShow = false;
    },
    //当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
    queryfirstValue(val) {
      val = val.filter(function (item, index, arr) {
        return arr.indexOf(item, 0) === index;
      });
      return val
    },
    //点击左侧All
    onlyTrans(val) {
      this.channelList.forEach(item => {
        item.showleft = true;
      });
      var that = this;
      let codeList = [];
      let codeList11 = [];
      let newList = [];
      let listAir = this.arrayforEach(this.Airline);
      if (val == 2) {
        //Origin
        this.OriginListshow = false;
        if (this.checkAirCount == 0) {
          this.channelList.forEach(item => {
            if (that.startAirList.includes(item.StartAirPortCode3)) {
              if (this.arrivalType) {
                item.showleft = (item.AirArrivalType == 1) ? true : false;
              }
            } else {
              item.showleft = false;
            }
            if (item.showleft) {
              newList.push(item)
              if (that.startAirList.includes(item.StartAirPortCode3)) {
                codeList.push(item.AirCompanyCode2);
                codeList11.push(item.StartAirPortCode3);
                return codeList, codeList11;
              }
            }
          });
          this.airlinelist = listAir;
          this.airlineOrigin = that.startAirList;
        } else {
          this.channelList.forEach(item => {
            if (that.airlinelist.includes(item.AirCompanyCode2)) {
              if (this.arrivalType) {
                item.showleft = (item.AirArrivalType == 1) ? true : false;
              }
            } else {
              item.showleft = false;
            }
            if (item.showleft) {
              newList.push(item)
              if (that.airlinelist.includes(item.AirCompanyCode2)) {
                codeList.push(item.AirCompanyCode2);
                codeList11.push(item.StartAirPortCode3);
                return codeList, codeList11;
              }
            }
          });
          this.airlinelist = this.airlinelist;
          this.airlineOrigin = that.startAirList;
        }
      }
      if (val == 3) {
        //Airline
        if (this.checkOreCount == 0) {
          //Airline
          this.channelList.forEach(item => {
            if (listAir.includes(item.AirCompanyCode2)) {
              if (this.arrivalType) {
                item.showleft = (item.AirArrivalType == 1) ? true : false;
              }
            } else {
              item.showleft = false;
            }
            if (item.showleft) {
              newList.push(item)
              if (listAir.includes(item.AirCompanyCode2)) {
                codeList.push(item.StartAirPortCode3);
                codeList11.push(item.AirCompanyCode2);
                return codeList, codeList11;
              }
            }
          });
          this.airlinelist = listAir;
          this.airlineOrigin = this.airlineOrigin;
        } else {
          this.channelList.forEach(item => {
            if (that.airlineOrigin.includes(item.StartAirPortCode3)) {
              if (this.arrivalType) {
                item.showleft = (item.AirArrivalType == 1) ? true : false;
              }
            } else {
              item.showleft = false;
            }
            if (item.showleft) {
              newList.push(item)
              if (that.airlineOrigin.includes(item.StartAirPortCode3)) {
                codeList.push(item.StartAirPortCode3);
                codeList11.push(item.AirCompanyCode2);
                return codeList, codeList11;
              }
            }
          });
          this.airlinelist = listAir;
          this.airlineOrigin = this.airlineOrigin;
        }
      }
      //当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
      this.airlineOrigin = this.queryfirstValue(this.airlineOrigin);
      this.airlinelist = this.queryfirstValue(this.airlinelist);
      this.getNewList(newList);
    },
    ClkSort(val) {
      this.isCheckSortBy = true
      this.orderSort = val;
      this.checkForm(val);
    },
    sortDensity(val) {
      this.isCheckSortBy = false;
      this.airlineOrigin = this.startAirList;
      this.airlinelist = this.arrayforEach(this.Airline);
      this.showMoreList = true;
      this.showStow = true;
      if (val == "General") {
        this.inputWeight = 167;
        this.inputCBM = 1;
        this.inputUnits = 1;
      } else if (val == "1:300") {
        this.inputWeight = 300;
        this.inputCBM = 1;
        this.inputUnits = 1;
      } else if (val == "1:500") {
        this.inputWeight = 500;
        this.inputCBM = 1;
        this.inputUnits = 1;
      } else if (val == "1:1000") {
        this.inputWeight = 1000;
        this.inputCBM = 1;
        this.inputUnits = 1;
      }
      this.curDensity = val;
      this.checkForm();
    },

    showDensity(weight) {
      if (weight < 300) {
        this.curDensity = "General";
      } else if (weight >= 300 && weight < 500) {
        this.curDensity = "1:300";
      } else if (weight >= 500 && weight < 1000) {
        this.curDensity = "1:500";
      } else {
        this.curDensity = "1:1000";
      }
    },
    showKg(Kg) {
      if (Kg > 0 && Kg < 100) {
        this.KgShowline = "45";
      } else if (Kg >= 100 && Kg < 300) {
        this.KgShowline = "100";
      } else if (Kg >= 300 && Kg < 500) {
        this.KgShowline = "300";
      } else if (Kg >= 500 && Kg < 1000) {
        this.KgShowline = "500";
      } else {
        this.KgShowline = "1000";
      }
    },
    //货物种类
    cargoInfoInfo(val) {
      let Cargoname = {
        CargoNameEn: '',
        CargoNameCn: ''
      }
      let cargonList = val.split(",")
      this.cargoInfo.forEach(item => {
        cargonList.forEach(v => {
          if (item.Id == v) {
            Cargoname.CargoNameEn = Cargoname.CargoNameEn + item.AttrVal_ContentEn + ",";
            Cargoname.CargoNameCn = Cargoname.CargoNameCn + item.AttrVal_Content + ",";
          }
        })
      });
      return Cargoname;
    },
    CustomerInquiryFn() {
      //数组排序    两个数组一一对应
      this.destListBox.sort((a, b) => {
        let order = this.destList;
        return order.indexOf(a) - order.indexOf(b);
      });
      // this.cargoVal.forEach((id)=>{
      if (this.cargoVal.length === 0 || this.cargoVal[0] == null)
        this.cargoVal[0] = sysCfg.air.Cargo.generalCargoID;
      this.selectedCargo = this.cargoInfo.filter(item => {
        return this.cargoVal.includes(item.Id);
      });
      let CargoNameEn = "";
      let CargoNameCn = "";
      let CargoTypeIDs = '';
      this.selectedCargo.forEach(item => {
        CargoNameEn = (CargoNameEn + item.AttrVal_ContentEn + ",");
        CargoNameCn = CargoNameCn + item.AttrVal_Content + ",";
        CargoTypeIDs = CargoTypeIDs + item.Id + ","

      });
      // })
      let desAllInfo;
      try {
        desAllInfo = this.destAirportList.filter(item => {
          return item.AirportCode3 === this.destListBox[this.destListBox.length - 1];
        })[0];
        if (!desAllInfo) {

          elAlert(this, "Please enter the destination airport");
          return false;
        }
      } catch (error) {
        // desAllInfo =

      }
      let customerInquiry = {
        stroeQuery: {
          GoodsReadyTime: new Date().Format("yyyy-MM-dd"),
          OrderServiceType: this.incotermsValue - 0,
          QueryGoodType: 2,
          startAirPortInfo: {},
          CargoTypeIDs: CargoTypeIDs.substring(0, CargoTypeIDs.lastIndexOf(','))
        },
        curAddress: {
          startAirPortInfo: this.startCityInfo,

          // startCityInfo
          //     startAirPortInfo:{
          //     AirportCode3: "SZX",
          //   AirportCode3Zj: "SZX",
          //   AirportCode4: "",
          //   AirportNameCh: "深圳",
          //   AirportNameChZj: "深圳",
          //   AirportNameEn: "Shenzhen",
          //   AirportNameEnZj: "Shenzhen",
          //   City_Key: "87928c0a-7344-4124-8abe-305115bdf476",
          //   CountryCode: "CN",
          //   CountryCodeZj: "CN        ",
          //   Id: "9b503254-1274-49d2-868e-11110269f901",
          //   MatchingStatus: null,
          //   Remark: null,
          //   Status: 1
          // },
          // desAllInfo:{
          //     AirportCode3: "LAX",
          //     AirportNameCh: "洛杉矶",
          //     AirportNameEn: "Los Angeles",
          //     CountryCode: "US",
          //     CountryNameCh: "美国",
          //     CountryNameEn: "United States",
          //     Country_Key: "4ae00ac2-0673-4b13-83fc-e15c72909610",
          //     IsHot: 7,
          //   },
          desAllInfo,
          desAirPortInfo: { AirportCode3: null }
        },
        CargoNameEn: CargoNameEn.substr(0, CargoNameEn.length - 1),
        CargoNameCn: CargoNameCn.substr(0, CargoNameCn.length - 1)
        // CargoNameEn,
        // CargoNameCn
      };
      sessionStorage.setItem(
        "customerInquiry",
        JSON.stringify(customerInquiry)
      );
      let routeUrl = this.$router.resolve({
        path: "/myInquiry/customerInquiry?from=checkList"
      });
      window.open(routeUrl.href, "_blank");
    },
    anyTimeNotContainAnd500Dialog() {
      if (this.anyTimeNotContain) {
        localStorage.setItem("anyTimeNotContain", true);
      } else {
        localStorage.setItem("anyTimeNotContain", false);
      }
    },
    incotermsType(val) {
      //服务类型 1：门到门，2：门到机场，3：机场到机场，4：机场到门，5：FOB，6：EXW，7：FCA
      let type = ""
      switch (val) {
        case "5":
          type = "FOB"
          break;
        case "6":
          type = "EXW"
          break;
        case "7":
          type = "FCA"
          break;
        default:
          type = ""
          break;
      }
      return type;
    },
    checkEnquiry() {
      this.isCheckSortBy = false;
      this.showStow = true;
      this.showMoreList = true
      this.checkForm();
    },
    //查询表单
    checkForm(val) {
      //需求  sort by同时带上左侧框的条件筛选
      if (val != undefined) {
        this.orderSort = val;
      } else {
        this.orderSort = "comprehensive";
        this.isCheckSortBy = false
        this.arrivalType = false;
      }
      let that = this;
      this.clearHistoryItems();//每次查价保存记录
      this.chooseArray = [];
      this.topQuery = true;
      this.isLoading = true;
      this.leftQuery = true;
      if (!this.isCheckSortBy) {
        this.arrivalType = false;
      }
      this.channelList.forEach(item => {
        item.showFee = false;
        item.showleft = true;
      });
      this.feeList = [];
      this.anyTimeNotContainAnd500Dialog();
      let cargoStrID = this.isOthers ? this.cargoVal.join(",") : null; //货物种类Id
      let cargoStrList = [];

      if (cargoStrID) {
        this.cargoInfo.filter(item => {
          if (this.cargoVal.includes(item.Id)) {
            cargoStrList.push(item.AttrVal_Content);
          }
          return cargoStrList;
        });
        cargoStrList = cargoStrList;
      } else {
        cargoStrList = ["普货"]
      }

      if (this.cargoVal.length === 0 || this.cargoVal[0] == null)
        this.cargoVal[0] = sysCfg.air.Cargo.generalCargoID;

      if (!this.cargoBox) {
        let startCityInfo = JSON.stringify(this.startCityInfo);
        if (startCityInfo == "{}" || this.startCityInfo == "") {
          this.checkTip.startCity =
            this.checkTip.startCity == undefined ||
              this.checkTip.startCity == ""
              ? "Required"
              : "";
          this.startCityenter = true;
          this.isLoading = false;
          return false;
        }
        //let checkValue = this.checkValue();
        let verification = this.Verification()
        if (!verification) {
          this.leftQuery = false;
          this.isLoading = false;
          return false
        }

      }
      if (!this.destListBox) {
        //this.destShow = true;
        elAlert(this, "Please enter the destination airport");
        return false;
      }
      let Kg = this.inputWeight;
      let CBM = this.inputCBM;
      let weight = this.InterceptUnit(Kg / CBM, 3);
      if (this.QueryType == 2) {
        if (this.weightValue == "KG") {
          Kg = this.InterceptUnit(this.inputWeight, 3);
          CBM = this.InterceptUnit(this.inputCBM, 4);
        } else {
          Kg = this.InterceptUnit(this.inputWeight * 0.4535924, 3);
          CBM = this.InterceptUnit(this.inputCBM * 0.0283168, 4);
        }
      } else {
        Kg = this.InterceptUnit(this.sumKG, 3);
        CBM = this.InterceptUnit(this.sumCBM, 3);
      }
      //当计费重》=500，或者货物类型里面有特殊货物的时候显示询盘按钮
      // 计算计费重
      let Bweight = CBM * 1000000 / 6000
      let chargeWeight = Kg > Bweight
        ? Math.ceil(Kg)
        : Math.ceil(Bweight)
      if ((chargeWeight >= 500 || (cargoStrID != '' && cargoStrID != this.geCargoID)) && this.destListBox) {
        this.inquiryShow = true;
      } else {
        this.inquiryShow = false;
      }

      this.showDensity(weight);
      this.showKg(Kg);
      //获取用户信息
      let U_info = JSON.parse(sessionStorage.getItem("customerInfos"));
      if (U_info) {
        this.customerOwnerType = U_info.CustomerOwnerType;
        this.CustomerID = U_info.CustomerID;
      }
      let Hkg;
      if (this.startCityInfo) {
        if (this.startCityInfo.CityCode == "HK") {
          Hkg = ["HKG"];
        }
      }
      // this.checkPrice('国际空运', this.startCityInfo.AirportCode3, '', this.destListBox.join(), (typeof this.DestCountry != String) ? this.DestCountry.join() : this.DestCountry, '',
      //   Number(this.inputWeight), Number(this.inputCBM), Number(this.inputUnits),
      //   cargoStrID === sysCfg.air.Cargo.generalCargoID ? false : true
      //   , cargoStrList, false, this.incotermsType(this.incotermsValue))
      //当选择货物信息时，只要包含了托盘，木箱和其他，就只显示托盘的价格
      //包材类型PackagingType 1：纸箱，2：托盘
      let PackagingType = 1;
      if (this.QueryType == 2 && this.unitValue != "CTNS") {//总的
        PackagingType = 2;
      }
      if (this.QueryType == 1) {
        let newCarg = this.radCargo.some((e) => {
          return e.Unit != 1
        })
        if (newCarg) {
          PackagingType = 2;
        }
      }

      this.queryParma = {
        skip: 0,
        take: 9999,
        orderBy: this.orderSort,
        // orderByDesc: "aa",
        customerID: this.CustomerID, //客户id
        customerOwnerType: this.customerOwnerType ? this.customerOwnerType : 2, //客户归属类型 0：直客，1：国内同行，2：海外同行
        startCityKey: this.startCityInfo.CityKey
          ? this.startCityInfo.CityKey
          : null, //起运城市Key
        orderServiceType: this.incotermsValue
          ? Number(this.incotermsValue)
          : null, //服务类型 1：门到门，2：门到机场，3：机场到机场，4：机场到门，5：FOB，6：EXW，7：FCA
        goodsReadyTime: new Date().Format("yyyy-MM-dd"), //"2021-06-24T06:25:09.016Z",//货好时间
        channelKey: null, //渠道Key
        channelOwnerType: 0, //渠道所属类型 0：普通渠道，1：大货渠道
        startAirportCodeList: Hkg ? Hkg : null, //起运机场列表 默认5大机场（上海、广州、香港、深圳、北京）
        destAirportCodeList: this.destListBox, //目的机场列表
        arrivalType: null, //到达类型
        airCompanyKeyList: null, //航空公司Key
        weight: this.inputWeight ? Number(this.inputWeight) : 500,
        volume: this.inputCBM ? Number(this.inputCBM) : 1.5,
        quantity: this.inputUnits ? Number(this.inputUnits) : 1, //件数
        cargoTypeIDList: cargoStrID ? cargoStrID.split(",") : [this.geCargoID], //货物种类ID
        PackagingType: PackagingType,
        "platformType": "web",
        "isLogin": true,
        "entrance": "Air Freight"
      };
      //console.log("=======>>>>",JSON.stringify(this.queryParma));
      let url = this.$api04 + "/Air/api/AirCalculation/QueryPriceEn";
      post(url, this.queryParma).then(res => {
        //console.log("=======>>>>res.Results",res.Results);
        if (res.IsOK == true) {
          that.searchResult(res.Results.Total, '国际空运', that.startCityInfo.AirportCode3, '', that.destList.join(), '', false)
          this.checkAirCount = 0;
          this.checkOreCount = 0;
          this.isLoading = false;
          let num = 0;
          this.channelList = res.Results.List;
          this.newList = this.channelList;
          //当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
          let airlist = this.airlinelist;
          airlist = airlist.filter(function (item, index, arr) {
            return arr.indexOf(item, 0) === index;
          });
          this.channelList.forEach(item => {
            if (!this.isCheckSortBy) {
              item.showFee = false;
              item.showleft = true;
              this.showKg(item.AirChargeWeight);
            }
            //排序：Sort by——每次筛选后的结果，均按照当前选中的排序方式排序
            this.airlineOrigin.forEach(val => {
              airlist.forEach(index => {
                if (index == item.AirCompanyCode2 && val == item.StartAirPortCode3) {
                  num += 1;
                  item.showFee = false;
                  if (that.arrivalType) {//直达
                    item.showleft = (item.AirArrivalType == 1) ? true : false;
                  } else {
                    item.showleft = true;
                  }

                  this.showKg(item.AirChargeWeight);
                  this.checkAirCount = 1;
                  this.checkOreCount = 1;
                }
              })
            })
          });
          //费用总和
          this.channelList.forEach(item => {
            let sumAll = 0;
            let sumSubtotal = 0;
            sumAll = item.AirTracficFee + item.THAmount;
            sumSubtotal = item.THAmount;
            if (item.LstAirFee) {
              item.LstAirFee.forEach(val => {
                sumAll += val.Amount;
                sumSubtotal += val.Amount;
              });
            }
            item.AllsumSubtotal = sumSubtotal;
            item.AllFee = sumAll;
          });

          this.Airline = res.Results.Airline;
          let codeList = [];
          this.Airline.filter(function (elem) {
            codeList.push(elem.Code);
            return codeList;
          });

          this.startAirList = res.Results.Origin;
          if (!that.isCheckSortBy) {
            this.airlineOrigin = res.Results.Origin;
            this.airlinelist = codeList;
            this.tiaoshu = 10;

          } else {
            this.tiaoshu = 10 + (this.channelList.length - num);
          }
          if (this.destList.length == 0) {
            this.destList = res.Results.Dest;
          }
          //this.destListBox = res.Results.Dest;
          this.cargoBox = false;
        } else {
          if (res.ErrorCode == "C0006") {
            this.leftQuery = false;
            this.isLoading = false;
            //this.destShow = true;
            elAlert(this, "Please enter the destination airport");
          } else {
            elAlert(this, "error");
          }
        }
      });

      this.CurAddress(); //存储当前地址库
      this.RecentStore(this.curAddress);
    },
    //获取空运渠道基本信息
    getAirChanne() {
      let param = "";
      let url = this.$api04 + "/Air/api/AirChannel/GetAirChannelList";
      post(url, param).then(res => {
        if (res.IsOK == true) {
          // this.queryRes = res.Results;
        } else {
          elAlert(this, "error");
        }
      });
    },
    //下单
    async enterBox(index, item) {
      let startCityInfo = JSON.stringify(this.startCityInfo);
      if (startCityInfo == "{}" || this.startCityInfo == "") {
        this.checkTip.startCity =
          this.checkTip.startCity == undefined || this.checkTip.startCity == ""
            ? "Required"
            : "";
        this.startCityenter = true;
        this.isLoading = false;
        return false;
      }
      let U_info = JSON.parse(sessionStorage.getItem("customerInfos"));
      //验证邮箱是否第一次下单   如果是第一次下单弹框确认邮箱是否正确
      let url = this.$api04 + "/Air/api/Email/EmailVerification";
      await post(url).then(res => {
        if (res.Results == true) {
          // this.queryRes = res.Results;
          this.Emailenter = true;
          this.indexed = index;
          if (U_info) {
            this.Email = U_info.Mail;
          }
          window.close();
        } else {
          let w = window.open();
          //不是第一次下单
          this.AirOrderEn(index, item, w); //西单
        }
      });
    },

    //确认邮箱之后事件
    insurBoxBtn() {
      let w = window.open();
      let url = this.$api04 + "/Air/api/Email/EnCustomerAuthentication";
      post(url).then(res => {
        if (res.IsOK == true) {
          this.Emailenter = false;
          this.AirOrderEn(this.indexed, "", w);
          // console.log("=====确认邮箱之后");
        } else {
          elAlert(this, "error");
        }
      });
    },
    othersClick(val) {
      if (val == "1") {
        this.isOthers = false;
        this.cargoTypeIDList = [Number(this.geCargoID)];
        this.cargoShow = false;
      } else {
        this.isOthers = true;
        //if (this.startCityInfo.CityKey) {
        this.cargoBox = true;
        this.cargoShow = true;
        this.chkGoodsItem("refresh");
        // } else {
        //   this.checkTip.startCity =
        //     this.checkTip.startCity == undefined ||
        //     this.checkTip.startCity == ""
        //       ? "Required"
        //       : "";
        //   this.cargoBox = false;
        // }
      }
    },
    //货物种类接口-空运
    getCargoApi() {
      this.api.param = {
        AttrMain_Code: "KYSHSpecial"
      };
      // this.api.url = this.$api01 + "/api/Attribute/QueryList";
      this.api.url = this.$api04 + "/Basics/api/Attribute/QueryList";
      post(this.api.url, this.api.param).then(res => {
        this.cargoInfo = res.Results[0].valList;
        this.cargoInfo.forEach(item => {
          this.$set(item, 'Id', item.AttrVal_ID);
        })
      });
    },
    closeCargoBox() {
      // this.cargoVal=[]
      this.showSHReport = false;
      // this.GenCargoVal=false
      // this.readInfo=null
      this.IsSHReport = null;
      this.isSum = false;
      this.startCityenter = false;
    },
    //选中哪些特殊货物
    chkGoodsItem(value) {

      if (value === "refresh") {
        if (this.readInfo) {
          return (this.isSum = true);
        }
        return;
      }

      if (value == this.geCargoID) {
        this.GenCargoVal = true;
        this.anyTimeNotContain = true;
        this.cargoVal = [this.geCargoID];
      } else {
        this.anyTimeNotContain = false;
        this.GenCargoVal = false;
      }

      if ($.inArray(value, this.cargoVal) >= 0) {
        if (value == this.geCargoID) {
          //是否勾选了普货
          this.cargoVal = [value];
        } else {
          //勾选中不是普货
          this.arrRemove(this.geCargoID, this.cargoVal);
        }
      }

      if ($.inArray(value, this.cargoVal) >= 0) {
        if (value == this.porCargoID) {
          //是否勾选了移动电源
          this.cargoVal = [value];
        } else {
          //勾选中不是移动电源
          this.arrRemove(this.porCargoID, this.cargoVal);
        }
      }

      if ($.inArray(value, this.cargoVal) >= 0) {
        if (value == this.batteryCargoID) {
          //是否勾选了纯电池
          this.cargoVal = [value];
        } else {
          //勾选中不是纯电池
          this.arrRemove(this.batteryCargoID, this.cargoVal);
        }
      }

      //空运选项：若所查询的起飞机场是上海，并且选择货物种类是内置电池1243、配套电池1242、让客户选择有无上海化工鉴定报告。选择无则不查出上海起飞的价格。
      let batArr = [
        sysCfg.air.Cargo.builtInBatID,
        sysCfg.air.Cargo.packedBatID
      ];
      let isTg = false; //是否存在以上的值
      //第一种方法： 查找两个数组之间的交集
      // batArr.forEach(item =>{
      //   if( $.inArray(item,this.cargoVal) > -1 ){
      //       isTg=true
      //       return false //结束循环
      //    }
      // })
      //第二种方法： 查找两个数组之间的交集
      let arrNew = [];
      arrNew = batArr.filter(v => this.cargoVal.includes(v));
      if (arrNew.length > 0) {
        isTg = true;
      }

      // console.log('startAirPort ' +  JSON.stringify(this.startAirPort));

      // if( this.startAirPort.item.AirportCode3=='PVG' && isTg==true){
      // this.showSHReport=true //显示上海化工材料
      // }else if(this.startAirPort.item.AirportCode3=='All airports'&&this.startAirPort.item.AirportCode3Zj.indexOf("PVG") != -1 && isTg==true){ //选择所有机场
      // this.showSHReport=true //显示上海化工材料
      // }else{
      // this.showSHReport=false //不不显示上海化工材料
      // this.IsSHReport=null
      // }

      if (this.showSHReport) {
        if (
          this.IsSHReport != null &&
          this.cargoVal.length > 0 &&
          this.readInfo
        ) {
          this.isSum = true;
        } else {
          this.isSum = false;
        }
      } else {
        if (this.cargoVal.length > 0 && this.readInfo) {
          this.isSum = true;
        } else {
          this.isSum = false;
        }
      }
    },
    //是否选中上海化工报告
    chgShrep() {
      if (this.showSHReport) {
        if (
          this.IsSHReport != null &&
          this.cargoVal.length > 0 &&
          this.readInfo
        ) {
          this.isSum = true;
        } else {
          this.isSum = false;
        }
      } else {
        if (this.cargoVal.length > 0 && this.readInfo) {
          this.isSum = true;
        } else {
          this.isSum = false;
        }
      }
    },
    //违禁品弹框
    clkreadBox() {
      this.$refs.contraRef.clkOpenBox();
    },
    //是否选中阅读违禁物品
    chgRead() {
      if (this.showSHReport) {
        if (
          this.IsSHReport != null &&
          this.cargoVal.length > 0 &&
          this.readInfo
        ) {
          this.isSum = true;
        } else {
          this.isSum = false;
        }
      } else {
        if (this.cargoVal.length > 0 && this.readInfo) {
          this.isSum = true;
        } else {
          this.isSum = false;
        }
      }
    },
    //js给根据数组元素删除数组中指定元素,不是根据索引
    arrRemove(val, arr1) {
      var index = $.inArray(val, arr1);
      if (index > -1) {
        arr1.splice(index, 1);
      }
    },
    changeValue(value) {
      if (value == "KG") {
        this.volumeValue = "CM";
        this.volumeValue1 = "CBM";
      }
      if (value == "LB") {
        this.volumeValue = "IN";
        this.volumeValue1 = "CFT";
      }
      if (value == "CM" || value == "CBM") {
        this.weightValue = "KG";
      }
      if (value == "IN" || value == "CFT") {
        this.weightValue = "LB";
      }
    },
    getUnit(unit, hasBill) {
      // 计费单位 目的地费用:（0：票，1：CBM，2：份，3：KG,4：页，5：单,6：天，7：次，8：件）
      switch (unit) {
        case 0:
          if (hasBill) {
            return "Bill";
          }
          return "B\\L";
        case 1:
          return "CBM";
        case 2:
          return "Pcs";
        case 3:
          return "KG";
        case 4:
          return "Page";
        case 5:
          if (hasBill) {
            return "Bill";
          }
          return "B\\L";
        case 6:
          return "Day";
        case 7:
          return "Time";
        case 8:
          return "Unit";
      }
    },
    // 处理总计
    delTotal() {
      this.channelList.forEach(ele => {
        var STotalFee = 0;
        var ETotalFee = 0;
        for (var i = 0; i < ele.LstAirFee.length; i++) {
          STotalFee += Number(ele.LstAirFee[i].Amount);
        }
        for (var i = 0; i < ele.LstDestFee.length; i++) {
          ETotalFee += Number(ele.LstDestFee[i].Amount);
        }
        ele.STotalFee = STotalFee.toFixed(2);
        ele.ETotalFee = ETotalFee.toFixed(2);
      });
    },
    // 展开
    openfee(Flagindex, list, item1) {
      let sumV = 0;
      this.channelList[Flagindex].showFee = !this.channelList[Flagindex]
        .showFee;
      if (!this.feeList.length) {
        this.feeList.push(Flagindex);
        return;
      }
      for (let i = 0; i < this.feeList.length; i++) {
        if (this.feeList[i] == Flagindex) {
          this.feeList.splice(i, 1);
          return;
        }
      }
      this.feeList.push(Flagindex);
    },
    //删除目的城市
    delDest(index, item) {
      // this.destList.splice(index, 1);
      // item = item.split();
      // this.destListBox = this.queryfirstValue(this.destListBox);
      // let list = this.destListBox;
      // if (this.destListBox.join() == this.destList.join()) {
      //   this.destListBox = this.destList;
      // } else {
      //   list[list.indexOf(item.join())] = null;
      //   this.destListBox = (list.join().trim()).split(",")
      // }
      // 删除显示数组中的
      this.destList.splice(index, 1);
      // 删除选中数组中的
      let checkIndex = this.destListBox.indexOf(item);
      if (checkIndex != -1) {
        this.destListBox.splice(checkIndex, 1);
      }
    },
    //选中目的城市
    handleChange1(name, index) {
      let boxDestList = [];
      //取消勾选目的国家
      if (index == 1) {
        boxDestList = this.destListBox;
        //取消目的国家
        let desAllInfo = this.destAirportList.filter(item => {
          return item.AirportCode3 === name;
        })
        let newDestCountry = [];
        for (let i = 0; i < this.DestCountry.length; i++) {
          if (this.DestCountry[i] = desAllInfo[0].CountryNameCh) {
            newDestCountry = this.DestCountry.slice(i + 1, this.DestCountry.length)
            break;
          }
        }
        this.DestCountry = newDestCountry
      } else {
        if (this.destList.indexOf(name.AirportCode3) == "-1") {
          this.destShow = false;
          this.destList.push(name.AirportCode3);
          if (this.destListBox.length != this.destList.length) {
            boxDestList = this.destListBox
            boxDestList.push(name.AirportCode3);
            this.DestCountry.push(name.CountryNameCh);//存储目的国家
          }
        } else {
          return false;
          //elAlert(this, "已存在");
        }
      }
    },
    //点击添加Dest
    addDest() {
      if (this.destList.length >= 10) {
        this.derNumber = true;
        //3秒之后自动隐藏
        setTimeout(() => {
          this.derNumber = false;
        }, 3000);
        return false
      } else {
        this.destShow = this.destShow == true ? false : true;
      }

      console.log(this.destList, 'this.destList');

    },
    //点击Origin的更多more
    clickMoreOri() {
      this.showOrigin = this.showOrigin == true ? false : true;
      this.originNum = this.showOrigin == true ? 5 : this.startAirList.length;
    },
    //点击Airline的更多more
    clickMore() {
      this.showMore = this.showMore == true ? false : true;
      this.toleNum = this.showMore == true ? 5 : this.Airline.length;
    },
    //是否直达
    onlyRoute() {
      let that = this;
      this.arrivalType = this.arrivalType ? true : false
      let type = this.arrivalType ? 1 : 2
      let newList = [];
      this.channelList.forEach(item => {
        if (type == 1) {
          if (
            that.airlineOrigin.includes(item.StartAirPortCode3) &&
            that.airlinelist.includes(item.AirCompanyCode2) && item.AirArrivalType == 1
          ) {
            newList.push(item);
            item.showleft = true;
          } else {
            item.showleft = false;
          }
        } else {
          if (
            that.airlineOrigin.includes(item.StartAirPortCode3) &&
            that.airlinelist.includes(item.AirCompanyCode2)
          ) {
            newList.push(item);
            item.showleft = true;
          } else {
            item.showleft = false;
          }
        }
      });
      this.getNewList(newList);
    },
    //选中一个或者only
    queryAirLine(val, item) {
      this.channelList.forEach(item => {
        item.showleft = true;
      });
      var that = this;
      let codeList = [];
      let boxList = [];
      let newList = [];
      if (val == 3) {
        //Origin
        if (item) {
          this.airlineOrigin = item.split();
        }
        this.channelList.forEach(item => {
          if (
            that.airlineOrigin.includes(item.StartAirPortCode3) &&
            that.airlinelist.includes(item.AirCompanyCode2)
          ) {

            if (this.arrivalType) {
              item.showleft = (item.AirArrivalType == 1) ? true : false;
            }
          } else {
            item.showleft = false;
          }
          if (item.showleft) {
            newList.push(item);
            if (boxList.includes(item.AirCompanyCode2)) {
              codeList.push(item.AirCompanyCode2);
              return codeList;
            }
          }
        });
        this.checkOreCount = 1;

      }
      if (val == 2) {
        //Airline
        if (item) {
          this.airlinelist = item.split();
        }
        this.channelList.forEach(item => {
          if (
            that.airlineOrigin.includes(item.StartAirPortCode3) &&
            that.airlinelist.includes(item.AirCompanyCode2)
          ) {
            if (this.arrivalType) {
              item.showleft = (item.AirArrivalType == 1) ? true : false;
            }
          } else {
            item.showleft = false;
          }
          if (item.showleft) {
            newList.push(item);
            if (boxList.includes(item.StartAirPortCode3)) {
              codeList.push(item.StartAirPortCode3);
              return codeList;
            }
          }
        });

        this.checkAirCount = 1;

      }
      this.getNewList(newList);

    },
    arrayforEach(array) {
      let list = [];
      if (array) {
        array.filter(function (item) {
          list.push(item.Code);
          return list;
        });
      }
      return list;
    },
    getSortQueryInArr(val, item) {
      var that = this;
      var isCunZaiObj = {
        isCunzai: false,
        indexKey: "0"
      };
      if (val == 3) {
        for (var i = 0; i < that.Airline.length; i++) {
          var citem = that.Airline[i];
          if (citem.Code == item.Code) {
            isCunZaiObj = {
              isCunzai: true,
              indexKey: i
            };
            break;
          }
        }
      }
      if (val == 2) {
        for (var i = 0; i < that.startAirport.length; i++) {
          var citem = that.startAirport[i];
          if (citem == item) {
            isCunZaiObj = {
              isCunzai: true,
              indexKey: i
            };
            break;
          }
        }
      }
      return isCunZaiObj;
    },

    //目的机场-接口
    getDestAirApi() {
      let that = this;
      that.api.param = {
        DataClass: 7
      };
      this.api.url = this.$api02 + "/api/EbayCustomer/Airport/QueryPort";
      post(this.api.url, this.api.param).then(res => {
        if (res.Results) {
          res.Results.forEach(item => {
            if (item.DataCode) {
              item.DataCode = item.DataCode.replace(/(^\s*)|(\s*$)/g, ""); //去除前后空格
            }
          });
          this.destAirportList = res.Results;

          if (this.WCAQueryCountryKey) {
            this.destAirportList = this.destAirportList.filter(item => {
              if (
                String(item.Country_Key).toUpperCase() ==
                this.WCAQueryCountryKey
              ) {
                return item;
              }
            });
          }
          this.bfDestAirPort = JSON.parse(JSON.stringify(this.destAirportList));
        }
      });
    },
    //搜索
    filterDestOpt(val) {
      //console.log("val的长度====",val);
      //目的机场搜索
      var search = val.toLowerCase();
      //console.log("看看搜索的是什么",search,val.length);
      //console.log("集合",this.bfDestAirPort);
      let destAirportList = [];
      if (val) {
        if (val.length <= 3) {//长度小于等于三的时候只检查三字码
          this.bfDestAirPort.filter(function (item) {
            if ((item.AirportCode3).toLowerCase().indexOf(search) != -1) {
              destAirportList.push(item);
            }
            return destAirportList
          });
          //没有三字码匹配的时候检索城市英文名匹配
          if (destAirportList.length == 0) {
            this.bfDestAirPort.filter(function (item) {
              if ((item.AirportNameEn).toLowerCase().indexOf(search) != -1) {
                destAirportList.push(item);
              }
              return destAirportList
            });
          }
        } else {
          //输入字符长度大于3时，直接检索城市英文名
          this.bfDestAirPort.filter(function (item) {
            if ((item.AirportNameEn).toLowerCase().indexOf(search) != -1) {
              destAirportList.push(item);
            }
            return destAirportList
          });
        }
        this.destAirportList = destAirportList
        // this.destAirportList = this.bfDestAirPort.filter(item => {
        //   let showTxt = `${item.AirportCode3}(${item.AirportNameEn})`;
        //   return showTxt.toLowerCase().indexOf(search) != -1;
        // });
      } else {
        this.destAirportList = this.bfDestAirPort;
      }
    },
    foucsData2() {
      this.destAirportList = this.bfDestAirPort;
    },
    //起运城市组件取值
    byCityValue(msg) {
      //console.log('msg1  ' + JSON.stringify(msg))
      this.startCityInfo = msg;
      if (!msg) {
        this.checkTip.startCity = "Required";
      } else {
        this.checkTip.startCity = "";
      }
      if (this.startCityInfo) {
        this.IsSHRShow(); //化工报告
      }
    },
    //查询地区是否由上海化工报告
    IsSHRShow() {
      let StartAreaObj = this.startCityInfo;
      //关联机场信息
      this.api.url =
        // this.$api01 +
        // "/api/InfoCustomer/AddressPortRelation/QueryAddressPortRelation";
        this.$api04 +
        "/Air/api/AddressPortRelation/QueryAddressPortRelation";
      this.api.param = {
        countryKey: StartAreaObj.CountryKey,
        provinceKey: StartAreaObj.ProvinceKey,
        cityKey: StartAreaObj.CityKey,
        relationType: 1
      };
      fetch(this.api.url, this.api.param).then(res => {
        var AddressPortRelation = res.Results;
        this.IsSHReportShow = AddressPortRelation.some(element => {
          return (
            element.RelationCode === "SHA" || element.RelationCode === "PVG"
          );
        });
      });
    },
    //  验证类
    checkNumInt(ctrValue) {
      if (ctrValue == 0) {
        ctrValue = "";
      }
      if (ctrValue) {
        ctrValue = ctrValue.replace(/\D/g, "");
        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;
        if (le > 4) {
          ctrValue = arr[0].substring(0, 4);
        }
      }
      return ctrValue;
    },
    //yz
    goBlur(val) {
      var type = `${val}Tip`;
      let cantZero = ["inputWeight", "inputCBM", "inputCFB", "inputLB"];
      if (cantZero.includes(val)) {
        if (Number(this[val]) <= 0) {
          this[val] = "";
          this.checkTip[type] = "Required";
        }
      }
      if (!this[val]) {
        this.checkTip[type] = "Required";
      } else {
        this.checkTip[type] = "";
      }
    },
    detailBlur(val, index) {
      //console.log(this.radCargo[index][val])
      if (
        val == "Long" ||
        val == "Wide" ||
        val == "Height" ||
        val == "LongIN" ||
        val == "WideIN" ||
        val == "HighIN"
      ) {
        if (
          this.radCargo[index][val] == 0 ||
          this.radCargo[index][val] == "."
        ) {
          this.radCargo[index][val] = "";
        }
        if (this.radCargo[index][val] == "") {
          this.radCargo[index].isCol2 = true;
        } else {
          this.radCargo[index].isCol2 = false;
        }
      } else if (val == "Quanlity") {
        if (
          this.radCargo[index][val] == 0 ||
          this.radCargo[index][val] == "."
        ) {
          this.radCargo[index][val] = "";
        }
        if (this.radCargo[index][val] == "") {
          this.radCargo[index].isCol1 = true;
        } else {
          this.radCargo[index].isCol1 = false;
        }
      } else if (val == "Weight" || val == "WeightLB") {
        if (
          this.radCargo[index][val] == 0 ||
          this.radCargo[index][val] == "."
        ) {
          this.radCargo[index][val] = "";
        }
        if (this.radCargo[index][val] == "") {
          // console.log(this.radCargo[index][val])
          this.radCargo[index].isCol3 = true;
        } else {
          this.radCargo[index].isCol3 = false;
        }
      }
    },
    checkNum(ctrValue) {
      if (ctrValue) {
        //ctrValue = ctrValue.replace(/^\./g, "");//验证第一个字符是数字而不是.
        ctrValue = ctrValue.replace(/[^\d\.]/g, "");
        if (ctrValue.indexOf(".") > -1) {
          let s = ctrValue.substring(ctrValue.indexOf(".") + 1);
          if (s.length > 3) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf(".") + 4);
          }
        }
        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;
        if (le > 7) {
          let int = arr[0].substring(0, 7);
          if (ctrValue.indexOf(".") > -1) {
            ctrValue = int + "." + arr[1];
          } else {
            ctrValue = int;
          }
        }
        return ctrValue;
      }
    },

    // 关闭报价更新弹框
    closeUpdateDialog(val) {
      this.requestDialog = false;
      // 复制报价
      if (val == 1) {
        this.copyDialog = true;
      }
    },
    // 关闭复制报价弹框
    closeCopyDialog(val) {
      this.copyDialog = false;
      if (val == 0) {
        this.chooseArray = [];
      }
    },
    chooseStatus(value) {
      this.status = value;

      this.getAirPriceStore();
    },
    // 复制报价操作
    async copyPriceAction(params) {
      let url = this.$api04 + "/Air/api/AirQueryPriceStore/GetCopyPriceStore";
      const list = {
        list: params
      };
      this.copyPriceList = params;
      const data = await post(url, list);
      if (data.IsOK) {
        // console.log(data);
        this.copyPriceData = data.Results;

        this.copyDialog = true;
      } else {
        // 报价更新了
        this.copyPriceData = data.Results;
        this.requestDialog = true;
      }
    },
    // 复制多条数据
    chooseAllCopy() {
      let that = this;
      // 判断是否选择了复制报价的信息
      if (this.chooseArray.length <= 0) {
        this.$message.error("please choose!");
        return false;
      }
      let newValue = {
        incotermsValue: this.incotermsValue,
        sumKG: this.inputWeight ? this.inputWeight : 500,
        sumCBM: this.inputCBM ? this.inputCBM : 1.5,
        volumeUnit: this.inputUnits ? this.inputUnits : 1,
        proportion: this.curDensity,
        CityNameEn: this.startCityInfo.CityNameEn
      };

      let list = [];
      list.push(newValue);
      this.chooseArray.filter(function (item) {
        list.push(that.newList[item]);
      });
      this.copyPriceData = list;
      this.copyDialog = true;
      //this.copyPriceAction(this.chooseArray);
    },
    // 复制单条数据
    async requestPrice(item) {
      // 判断是否选择了复制报价的信息
      // if (!this.chooseArray.includes(item)) {
      //   this.$message.error("please choose!");
      //   return false;
      // }
      let newValue = {
        incotermsValue: this.incotermsValue,
        sumKG: this.inputWeight ? this.inputWeight : 500,
        sumCBM: this.inputCBM ? this.inputCBM : 1.5,
        volumeUnit: this.inputUnits ? this.inputUnits : 1,
        proportion: this.curDensity,
        CityNameEn: this.startCityInfo.CityNameEn
      };
      let list = [];
      let airlist = this.newList[item]; //当前渠道

      list.push(newValue);
      list.push(airlist);
      this.copyPriceData = list;
      this.copyDialog = true;
      ////this.copyPriceAction([item]);
    },
    // 选中复制报价
    chooseData(item) {
      //console.log("=========item",item);
      let id = item;
      if (this.chooseArray.includes(id)) {
        let chooseIndex = this.chooseArray.indexOf(id);
        // 取消选中
        this.chooseArray.splice(chooseIndex, 1);
      } else {
        // 选中
        this.chooseArray.push(id);
      }
    },
    //弹窗是否删除框
    delTipBond(id) {
      this.delID = id; //当前删除的id
      this.delTipBox = true;
    },
    //确定删除
    defineDel() {
      this.DelQuery(this.delID);
      this.delTipBox = false;
    },

    //点击增加图标
    addPackItem() {
      let opt = {
        Quanlity: "",
        Long: "",
        Wide: "",
        Height: "",
        High: "",
        Volume: "",
        Weight: "",
        LongIN: "",
        WideIN: "",
        HighIN: "",
        VolumeCFT: "",
        WeightLB: "",
        isCol1: false,
        isCol2: false,
        isCol3: false,
        unitOptions: [
          { value: 1, label: "Carton" },
          { value: 2, label: "Pallet" },
          { value: 3, label: "Wooden Case" },
          { value: 4, label: "Other" }
        ],
        Unit: 1
      };
      return opt;
    },
    //货件信息
    addPackage() {
      //增加包裹
      this.radCargo.push(this.addPackItem());
    },
    delPackage(index) {
      //删除包裹
      if (this.radCargo.length > 1) {
        this.radCargo.splice(index, 1);
      }
    },

    //存储费用集合
    AirFeeBox(index) {
      let that = this;
      let airlist = this.newList[index]; //当前渠道
      let airFeeList = [];
      if (airlist.LstAirFee.length > 0) {
        airlist.LstAirFee.filter(function (item) {
          let airFeeList1 = {};
          if (item.MinValue) {
            airFeeList1 = {
              CostType: 2, //费用类型  1:空运费 2：本地费
              CostName: item.FeeNameEn, //费用名称
              UnitRate:
                item.UnitPrice.toFixed(2) + "/" + that.getUnit(item.Unit, true), //单价
              Quantity: String(item.Quanlity) + that.getUnit(item.Unit), //数量
              Amount: item.Amount.toFixed(2), //金额
              MinValue: item.MinValue // 最低价
            };
          } else {
            airFeeList1 = {
              CostType: 2, //费用类型  1:空运费 2：本地费
              CostName: item.FeeNameEn, //费用名称
              UnitRate:
                item.UnitPrice.toFixed(2) + "/" + that.getUnit(item.Unit, true), //单价
              Quantity: String(item.Quanlity) + that.getUnit(item.Unit), //数量
              Amount: item.Amount.toFixed(2) //金额
            };
          }

          airFeeList.push(airFeeList1);
        });
      }

      let airFee = {
        CostType: 1, //费用类型
        CostName: "Air Freight Cost", //费用名称
        UnitRate: airlist.AirPrice.toFixed(2) + "/KG", //单价
        Quantity: String(airlist.AirChargeWeight) + "KG", //数量
        Amount: airlist.AirTracficFee.toFixed(2) //金额
      };

      let name = "";
      if (airlist.ThWorkDay) {
        let days = airlist.ThWorkDay != 1 ? "days" : "day";
        name = "Pickup Charge (" + airlist.ThWorkDay + days + ")";
      } else {
        name = "Pickup Charge";
      }

      if (airlist.THAmount) {
        let thAmount = {
          CostType: 3, //费用类型
          CostName: name, //费用名称
          UnitRate: airlist.THAmount.toFixed(2) + "/Bill", //单价
          Quantity: "1 Shipment", //数量
          Amount: airlist.THAmount.toFixed(2) //金额
        };
        airFeeList.push(thAmount);
      }

      airFeeList.push(airFee);
      this.airFeeList = airFeeList;
    },

    //数据当前地址
    CurAddress() {
      let startCityInfo = "";
      startCityInfo = this.startCityInfo;
      this.curAddress = {
        startCityInfo: startCityInfo
      };
    },
    // 重要功能
    RecentStore(Info) {
      let startCityIndex = -1;
      for (let i = 0; i < this.Recent.StartCity.length; i++) {
        const ele = this.Recent.StartCity[i];
        if (ele.CityKey == Info.startCityInfo.CityKey) {
          startCityIndex = i;
        }
      }
      if (Info.startCityInfo) {
        if (startCityIndex !== -1) {
          this.Recent.StartCity.splice(startCityIndex, 1);
        } else {
          if (this.Recent.StartCity.length >= 20) {
            this.Recent.StartCity.splice(20, 1);
          }
        }
        this.Recent.StartCity.unshift(Info.startCityInfo);
      }
      this.Recent.Time = new Date();
      let obj = JSON.stringify(this.Recent);
      localStorage.setItem("En-recent", obj);
    },
    getRecent() {
      if (typeof Storage == undefined) {
        return false;
      }
      if (localStorage.getItem("En-recent")) {
        this.Recent = JSON.parse(localStorage.getItem("En-recent"));
        let EndTime = new Date(
          new Date().setMonth(new Date(this.Recent.Time).getMonth() - 3)
        );
        let Flag = new Date().getTime() - EndTime;
        if (Flag < 0) {
          localStorage.removeItem("En-recent");
        }
      }
    },

    //存储报价
    AirPriceStoreBox(index) {
      this.AirQueryPriceStore(index);

      // let _this = this
      // this.$confirm( 'Are you sure you want to store the Price?','',  {
      //   customClass:'custom-message-box', //自定义添加Class
      //   confirmButtonText: 'Confirm',
      //   cancelButtonText: 'Cancel',
      //   cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
      //   closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
      //   showCancelButton:true,//去掉取消按钮
      //   showClose:false,//去掉右上角的取消（X）
      //   // type: 'warning',
      //   center: true
      // }).then(() => {
      //   _this.AirQueryPriceStore(index)
      // }).catch(() => {
      // });
    },

    //存储报价接口
    AirQueryPriceStore(index) {
      this.AirFeeBox(index);
      this.curChannelList = this.newList[index]; //当前渠道
      this.api.url =
        this.$api04 + "/Air/api/AirQueryPriceStore/SaveAirQueryPriceStore";
      this.api.param = {
        StoreType: 1, //报价类型
        OrderServiceType: Number(this.incotermsValue), //订单服务类型
        StartCountryKey: "3c48f3d4-8f99-4721-9e88-2ff6f77b10bf", //起始国家key
        StartCountryNameCn: "中国", //起始国家中文名
        StartCountryNameEn: "China", //起始国家英文名
        // "LstDestinationTerms": this.stroeQuery.LstDestinationTerms,
        StartProKey: this.curChannelList.StartProvinceKey, //起始省份key
        StartProNameCn: this.curChannelList.StartProvinceNameCn, //起始省份中文名
        StartProNameEn: this.curChannelList.StartProvinceNameEn, //起始省份英文名
        StartCityKey: this.curChannelList.StartCityKey, //起始城市key
        StartCityNameCn: this.curChannelList.StartCityNameCn,
        StartCityNameEn: this.curChannelList.StartCityNameEn,
        StartCityAreaKey: null, //起始区域key
        StartCityAreaNameCn: null,
        StartCityAreaNameEn: null,
        DestCountryKey: this.curChannelList.DestCountryKey, //目的国家key
        DestCountryNameCn: null,
        DestCountryNameEn: null,
        DestProKey: null, //目的省份key
        DestProNameCn: null,
        DestProNameEn: null,
        DestCityKey: null, //目的城市key
        DestCityNameCn: null,
        DestCityNameEn: null,
        AirCompanyKey: this.curChannelList.AirCompanyKey, //航空公司key
        AirCompanyCode: this.curChannelList.AirCompanyCode2, //
        AirCompanyName: this.curChannelList.AirCompanyName,
        DepartureCode: this.curChannelList.StartAirPortCode3,
        DepartureName: this.curChannelList.StartAirportName,
        DepartureNameEn: this.curChannelList.StartAirportNameEn,
        DestinationCode: this.curChannelList.DestAirPortCode3,
        DestinationName: this.curChannelList.DestAirportName,
        DestinationNameEn: this.curChannelList.DestAirportNameEn,
        TransferAirPort: this.curChannelList.TransferAirportCode3, //中转机场
        PlanDeliveryTime: new Date().Format("yyyy-MM-dd"), //货好时间
        // "PlanDeliveryTime": "2019-08-20" ,
        PackageQuanlity: this.inputUnits ? Number(this.inputUnits) : 1, //总件数
        Weight: this.inputWeight ? Number(this.inputWeight) : 500, //实重
        VolumeCBM: this.inputCBM ? Number(this.inputCBM) : 1.5, //体积CBM
        CargoIDs: this.cargoVal.join(","), //货物种类IDs
        IsDestCustoms: false, //是否需要目的地
        IsBond: false, //是否购买Bood
        BondType: 1, //购买bood类型
        // 这个BondValue 是 Bond内的输入的值
        BondValue: this.curChannelList.BondAmount, //bood货物价值
        IsSHReport: false, //有无上海化工鉴
        OrderTrafficAmount: this.curChannelList.AirTracficFee, //下单运费
        OrderAmount: this.curChannelList.TotalFee, //下单金额
        ValidTerm: this.curChannelList.ValidTerm, //时效
        PriceValidDate: new Date(this.curChannelList.AirValidEndTime).Format(
          "yyyy-MM-dd"
        ), //价格有效期至
        ChannelKey: this.curChannelList.AirChannelKey, //空运渠道
        ChannelName: this.curChannelList.AirChannelName, //空运渠道名称
        AirCompanyCode3: this.curChannelList.AirCompanyCode3, //
        DestAddressDesc: "", //目的地地址信息
        firstFlight: this.curChannelList.Flight, //航班
        unitPrice: this.curChannelList.AirPrice, //单价
        proportion: this.curDensity, //比重段
        LstDestinationTerms: [this.incotermsValue],
        queryPriceStoreCostItem: this.airFeeList
      };
      //console.log("=====", JSON.stringify(this.api.param));
      post(this.api.url, this.api.param).then(res => {
        if (res.IsOK) {
          this.$confirm("Saved successfully", "", {
            customClass: "custom-message-box", //自定义添加Class
            confirmButtonText: "Go to view",
            cancelButtonText: "Close",
            cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
            closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
            showCancelButton: true, //去掉取消按钮
            showClose: false, //去掉右上角的取消（X）
            // type: 'warning',
            center: true
          })
            .then(() => {
              this.$router.push({
                path: "/myInfo/myAirPriceStore"
              });
            })
            .catch(() => { });
        } else {
          this.$alert("Saved fail", "", {
            customClass: "custom-message-box", //自定义添加Class
            confirmButtonText: "Confirm",
            cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
            closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
            // showCancelButton:false,//去掉取消按钮
            showClose: true, //去掉右上角的取消（X）
            // type: 'warning',
            center: true
          })
            .then(() => { })
            .catch(() => { });
        }
      });
    },
    // 下单接口
    AirOrderEn(index, item, w = {}) {
      ///console.log("订单目的国家=====",this.startCityInfo);
      this.curChannelList = this.newList[index]; //当前渠道
      //debugger
      //console.log("======>>>>>>",this.curChannelList.THStartCityAreaKey);
      console.log(item, "ietsad");
      let VolumeCFT = Number(this.inputCBM) * 35.3147248;
      let WeightLB = Number(this.inputWeight) * 2.2046226;
      if (this.QueryType == 1) {
        this.inputWeight = this.sumKG;
        this.inputCBM = this.sumCBM;
        this.inputUnits = this.sumUnit;
        WeightLB = this.sumLB;
        VolumeCFT = this.sumCFT;
      }
      if (
        (this.QueryType == 2 && this.weightValue == "LB") ||
        this.volumeValue1 == "CFT"
      ) {
        VolumeCFT = this.inputCBM;
        WeightLB = this.inputWeight;
      }
      let cargoId = this.cargoVal.join(",")
        ? this.cargoVal.join(",")
        : this.geCargoID
      let cargoInfoName = this.cargoInfoInfo(cargoId);
      (this.api.param = {
        Order: {
          AirChannelKey: this.curChannelList.AirChannelKey,
          AirCompanyKey: this.curChannelList.AirCompanyKey,
          AirCompanyCode: this.curChannelList.AirCompanyCode2,
          AirCompanyName: this.curChannelList.AirCompanyName,
          DepartureCode: this.curChannelList.StartAirPortCode3,
          DepartureName: this.curChannelList.StartAirportName,
          DestinationCode: this.curChannelList.DestAirPortCode3,
          DestinationName: this.curChannelList.DestAirportName,
          FlightInfo: this.curChannelList.Flight,
          ValidTerm: this.curChannelList.ValidTerm,
          AirArrivalType: this.curChannelList.AirArrivalType,
          OrderPrice: this.curChannelList.AirPrice,
          OrderAmount: this.curChannelList.TotalFee,
          OrderTrafficAmount: this.curChannelList.AirTracficFee,
          OrderWeight: this.curChannelList.AirChargeWeight,
          PackageUnit: this.unitValue,
          SecondFlight: this.curChannelList.SecondFlight,
          TransferAirport: this.curChannelList.TransferAirportCode3,
          AirChannelName: this.curChannelList.AirChannelName,
          DepartureNameEn: this.curChannelList.StartAirportNameEn,
          DestinationNameEn: this.curChannelList.DestAirportNameEn,
          AirCompanyCode3: this.curChannelList.AirCompanyCode3,
          WeightLB: Number(WeightLB),
          VolumeCFT: Number(VolumeCFT),
          QueryGoodUnit: this.weightValue == "KG" ? 0 : 1,
          Weight: Number(this.inputWeight),
          PackageQuanlity: Number(this.inputUnits),
          VolumeCBM: Number(this.inputCBM),
          PlanDeliveryTime: new Date().Format("yyyy-MM-dd"), //货好时间
          OrderServiceType: Number(this.incotermsValue), //服务类型
          QueryGoodType: this.QueryType, //货件查询类型
          CargoIDs: cargoId,
          CargoNameEn: cargoInfoName.CargoNameEn.substr(0, cargoInfoName.CargoNameEn.length - 1),
          CargoNameCn: cargoInfoName.CargoNameCn.substr(0, cargoInfoName.CargoNameCn.length - 1)
        },
        OrderExt: {
          StartCityAreaKey: this.curChannelList.THStartCityAreaKey,
          StartCountryKey: "3c48f3d4-8f99-4721-9e88-2ff6f77b10bf",
          StartCountryNameCn: "中国",
          StartCountryNameEn: "China",
          StartProKey: this.curChannelList.StartProvinceKey,//this.startCityInfo.ProvinceKey,
          StartProNameCn: this.curChannelList.StartProvinceNameCn,
          StartProNameEn: this.curChannelList.StartProvinceNameEn,
          StartCityKey: this.curChannelList.StartCityKey,
          StartCityNameCn: this.curChannelList.StartCityNameCn,
          StartCityNameEn: this.curChannelList.StartCityNameEn,
          DestCountryKey: null,
          DestCountryNameCn: null,
          DestCountryNameEn: null,
          DestAddressDesc: "",
          DestSvcID: this.curChannelList.DestSvcID,
          THChannelKey: this.curChannelList.THChannelKey,
          IsStartCustoms: null,
          IsDestCustoms: false,
          IsBond: false,
          BondType: 1,
          BondValue: this.curChannelList.BondAmount,
          DestSvcID: this.curChannelList.DestSvcID,
          OrderCostUnitPrice: item.CostUnitPriceTar, //成本单价(目标币种)
          OrderCostCurrency: 2,//币种 英文网传美元
        },
        GoodVolumeList: null,//this.QueryType == 1 ? this.radCargo : null,
        DeliverOrder: {
          DestSvcID: this.curChannelList.DestSvcID
        },
        LstDestinationTerms: [this.incotermsValue],
        FeeItem:
          this.curChannelList.LstAirFee.length != 0
            ? this.curChannelList.LstAirFee
            : null //this.curChannelList.LstAirFee.concat(this.curChannelList.LstDestFee),
      }),
        (this.api.url =
          this.$api03 + "/api/TradeCustomer/AirOrderEn/AddConfirmOrder");

      // console.log("=====下单参数",JSON.stringify(this.api.param));
      // let newWindow = window.open();
      post(this.api.url, this.api.param).then(res => {
        if (res.IsOK == true) {
          //this.submitOrder(res.Results.WaybillNO, item.TotalFee, '', '国际空运', this.startCityInfo.CityNameCh, '', this.curChannelList.DestAirportNameEn, '', '',
          //  Number(this.inputWeight), Number(this.inputCBM), Number(this.inputUnits), item.AirChargeWeight, '', item.AirChannelName, item.AirTracficFee, '', '', false)
          // this.yzSuccess = true
          // this.$router.push({
          //   path: "/air/airEdit",
          //   query: {ord:res.Results.WaybillNO}
          // })
          w.location.href = "/air/airEdit?ord=" + res.Results.WaybillNO;
        } else {
          // console.log("看看是什么错",res);
          elAlert(this, "error");
          window.close();
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/air/checkForworder.js